import React from "react";
import {Table} from "reactstrap";

interface NetworkMetricsVerticalProps {
  udpMetrics?: {
    maxStc: number;
    avgStc: number;
    maxCts: number;
    avgCts: number;
    sumRxErrors: number;
    sumTxErrors: number;
    crowdingScore: number;
    crowdingTier: string;
  };
}

const NetworkMetricsVertical: React.FC<NetworkMetricsVerticalProps> = ({udpMetrics}) => {
  if (!udpMetrics) {
    return null;
  }

  // Crowding classification for CSS classes
  const getCrowdingCssClassName = (tier: string): string => {
    return tier.toLowerCase();
  };

  return (
    <div className="network-metrics-vertical">
      <h6 className="text-muted mb-2">
        <i className="fa fa-wifi mr-2"></i>
        Network
      </h6>
      <Table size="sm" className="side-metrics">
        <tbody>
          <tr>
            <td>Max StC</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers stc small">{udpMetrics.maxStc}</div>
            </td>
          </tr>
          <tr>
            <td>Avg StC</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers stc avg small">{udpMetrics.avgStc}</div>
            </td>
          </tr>
          <tr>
            <td>Max CtS</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers cts small">{udpMetrics.maxCts}</div>
            </td>
          </tr>
          <tr>
            <td>Avg CtS</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers cts avg small">{udpMetrics.avgCts}</div>
            </td>
          </tr>
          <tr>
            <td>Crowding</td>
            <td style={{textAlign: "right"}}>
              <div className={`numbers crowding ${getCrowdingCssClassName(udpMetrics.crowdingTier)} small`}>
                {Math.round(udpMetrics.crowdingScore * 100)}%
              </div>
            </td>
          </tr>
          <tr>
            <td>Crowding</td>
            <td style={{textAlign: "right"}}>
              <div className={`numbers crowding ${getCrowdingCssClassName(udpMetrics.crowdingTier)} small`}>
                {udpMetrics.crowdingTier}
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default NetworkMetricsVertical;
